module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-mobile-3e7a080f8b87fd13c9781b7737a96b2c.webp";